import { Col } from '@rematter/ui-web';

import { ComplianceCheckPanel } from './ComplianceCheckPanel';
import { ComplianceHoldPanel } from './ComplianceHoldPanel';

export const PurchaseLoadTabCompliance = () => (
  <Col gap5 className="@PurchaseLoadTabCompliance h-full overflow-y-auto p-5">
    <ComplianceCheckPanel />
    <ComplianceHoldPanel />
  </Col>
);
